<div class="card h-100 shadow" (click)="goToDetail(event.slug)">
    <img src="{{event.thumbnail}}" class="card-img-top" alt="...">
    <div class="card-body"> 
        <div class="card-title"><h6>{{event.name}}</h6></div>
        <p class="card-text text-fix">Some quick example text to build on the card title and make up 
        the bulk of the card's content.</p>
    </div>
</div>